// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file user/user_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { DeepLinkInfo } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';

/**
 * Describes the file user/user_model.proto.
 */
export const file_user_user_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChV1c2VyL3VzZXJfbW9kZWwucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0ItUCCgRVc2VyEgoKAmlkGAEgASgDEhIKBXBob25lGAIgASgJSACIAQESEAoIdXNlcm5hbWUYAyABKAkSFgoJYXZhdGFyVXJsGAQgASgJSAGIAQESEAoIbmlja25hbWUYBSABKAkSFQoIcG9zaXRpb24YBiABKAlIAogBARISCgVlbWFpbBgHIAEoCUgDiAEBEhAKCHVwZGF0ZVRzGAggASgDEhYKCWZpcnN0TmFtZRgJIAEoCUgEiAEBEhUKCGxhc3ROYW1lGAogASgJSAWIAQESFwoKbWlkZGxlTmFtZRgLIAEoCUgGiAEBEhMKC2Rpc3BsYXlOYW1lGAwgASgJQggKBl9waG9uZUIMCgpfYXZhdGFyVXJsQgsKCV9wb3NpdGlvbkIICgZfZW1haWxCDAoKX2ZpcnN0TmFtZUILCglfbGFzdE5hbWVCDQoLX21pZGRsZU5hbWUijAEKEFBlcnNvbmFsaXplZFVzZXISKAoEdXNlchgBIAEoCzIaLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVzZXISFAoMbGFzdE9ubGluZVRzGAIgASgDEjgKDGRlZXBMaW5rSW5mbxgDIAEoCzIiLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkRlZXBMaW5rSW5mbyKOAQoKVXNlclN0YXR1cxIOCgZ1c2VySWQYASABKAMSNwoGc3RhdHVzGAIgASgOMicuY29tLmdlbS5iZmYuY29udHJhY3QuVXNlclN0YXR1cy5TdGF0dXMSFAoMbGFzdE9ubGluZVRzGAMgASgDIiEKBlN0YXR1cxIKCgZPTkxJTkUQABILCgdPRkZMSU5FEAFCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_common_common_model]
  );

/**
 * @generated from message com.gem.bff.contract.User
 */
export type User = Message<'com.gem.bff.contract.User'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string phone = 2;
   */
  phone?: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: optional string avatarUrl = 4;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string nickname = 5;
   */
  nickname: string;

  /**
   * @generated from field: optional string position = 6;
   */
  position?: string;

  /**
   * @generated from field: optional string email = 7;
   */
  email?: string;

  /**
   * @generated from field: int64 updateTs = 8;
   */
  updateTs: bigint;

  /**
   * @generated from field: optional string firstName = 9;
   */
  firstName?: string;

  /**
   * @generated from field: optional string lastName = 10;
   */
  lastName?: string;

  /**
   * @generated from field: optional string middleName = 11;
   */
  middleName?: string;

  /**
   * @generated from field: string displayName = 12;
   */
  displayName: string;
};

/**
 * Describes the message com.gem.bff.contract.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/ messageDesc(file_user_user_model, 0);

/**
 * @generated from message com.gem.bff.contract.PersonalizedUser
 */
export type PersonalizedUser = Message<'com.gem.bff.contract.PersonalizedUser'> & {
  /**
   * @generated from field: com.gem.bff.contract.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: int64 lastOnlineTs = 2;
   */
  lastOnlineTs: bigint;

  /**
   * @generated from field: com.gem.bff.contract.DeepLinkInfo deepLinkInfo = 3;
   */
  deepLinkInfo?: DeepLinkInfo;
};

/**
 * Describes the message com.gem.bff.contract.PersonalizedUser.
 * Use `create(PersonalizedUserSchema)` to create a new message.
 */
export const PersonalizedUserSchema: GenMessage<PersonalizedUser> =
  /*@__PURE__*/
  messageDesc(file_user_user_model, 1);

/**
 * @generated from message com.gem.bff.contract.UserStatus
 */
export type UserStatus = Message<'com.gem.bff.contract.UserStatus'> & {
  /**
   * @generated from field: int64 userId = 1;
   */
  userId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.UserStatus.Status status = 2;
   */
  status: UserStatus_Status;

  /**
   * @generated from field: int64 lastOnlineTs = 3;
   */
  lastOnlineTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.UserStatus.
 * Use `create(UserStatusSchema)` to create a new message.
 */
export const UserStatusSchema: GenMessage<UserStatus> =
  /*@__PURE__*/
  messageDesc(file_user_user_model, 2);

/**
 * @generated from enum com.gem.bff.contract.UserStatus.Status
 */
export enum UserStatus_Status {
  /**
   * @generated from enum value: ONLINE = 0;
   */
  ONLINE = 0,

  /**
   * @generated from enum value: OFFLINE = 1;
   */
  OFFLINE = 1,
}

/**
 * Describes the enum com.gem.bff.contract.UserStatus.Status.
 */
export const UserStatus_StatusSchema: GenEnum<UserStatus_Status> =
  /*@__PURE__*/
  enumDesc(file_user_user_model, 2, 0);
